module.exports = __webpack_public_path__ + "static/media/blueArrow.ac77f9fb.svg";